export const EMU_2018_BOUNDARY_LAYER_ID = 'fb49b7b2e9c54df396ff83324f7bd672';
export const EMU_2018_BOUNDARY_LAYER_FIELDS = {
    DEPTH_LEVEL: 'Depth_Level',
    DEPTH: 'Depth',
    EMU: 'EMU_2018',
};
